import { render } from "./AddAdmin.vue?vue&type=template&id=ea99c5e4&scoped=true"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"

import "./AddAdmin.vue?vue&type=style&index=0&id=ea99c5e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea99c5e4"]])

export default __exports__